import React from 'react';
import classnames from "classnames";

class RegisteredUsers extends React.Component {

    constructor(props) {
        super(props);
        this.handleSelection = this.handleSelection.bind(this);
    }

    render() {
        const {active, config, activePayments} = this.props,
            {messages} = config;

        // From the React docs, we can return null when we don't want a component to render
        // See https://reactjs.org/docs/conditional-rendering.html
        if (!active ) {
            return null;
        }

        let elements = [];

        function sharedRegisteredUsers(activePayments) {

            //loop through payments to create shared registered user list. Registered users in case of multiple accounts will only show
            //if different accounts have a shared customer Id. This will allow the wallet from user to be used on multiple accounts.

            let allUsers = [];
            let sharedUsers = [];
            activePayments.map( payment => {
                allUsers = allUsers.concat(payment.users);
            });

            //Technically  if a user is shared we should have an associated user with each of the account
            allUsers.forEach((user) => {
                if ((allUsers.filter(n => user.loginId == n.loginId)).length == activePayments.length) {
                    sharedUsers.push(user);
                }
            });

            //Final step is to remove showing duplicate users.
            sharedUsers = sharedUsers.filter(n => n.wallet.length>0).filter((v,i,a)=>a.findIndex(v2=>(v2.loginId===v.loginId))===i)

            return sharedUsers;
        }

        let registeredUsers = activePayments.length==1? activePayments[0].users : sharedRegisteredUsers(activePayments);

        // renders a radio button for each user
        registeredUsers.forEach((user, idxUser) => {

            const userWalletIcons = user.wallet.map((walletItem, idx) =>
                (
                    <span
                        key={`wallet-${idx}`}
                        className={classnames("ml-1", "pm-icon", "pm-icon-inline", getCardCssClass(walletItem.type))}>
                        &nbsp;
                    </span>
                )
            );

            // each client account renders as the following element
            elements.push(
                <div  className="row" key={`user-${idxUser}`}>
                    <div className="col">
                        <div className="ru-user-row">
                            <input
                                onClick={() => this.handleSelection(user)}
                                className="form-check-input"
                                type="radio"
                                id={"user-" + user.email}
                                name="header.userId"/>
                            <label className="form-check-label col ru-label" htmlFor={"user-" + user.email}>
                                <div className="row">
                                    <div className="col-7">
                                        {this.getDisplayUserName(user)}
                                    </div>
                                    <div className="col-5">
                                        {userWalletIcons}
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            );

        });

        // Add an extra row for selecting none of the above
        elements.push(
            <div  className="row" key={`user-none`}>
                <div className="col">
                    <div className="ru-user-row">
                        <input
                            className="form-check-input"
                            type="radio"
                            id={"user-none"}
                            name="header.userId"/>
                        <label className="form-check-label col ru-label" htmlFor={"user-none"}>
                            <div className="row">
                                <div className="col-7">
                                    {messages["opp.noRegisteredUsers.label"]}
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        );

        return (
            <div id="RegisteredUsers" className={"opp-section" + (!active ? " disable-section" : "")}>
                <h3 className="section-title">
                    <span className="section-text">{messages["opp.registeredUsers.label"]}</span>
                </h3>
                <div className="card card-v2">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="md-form form-group mb-2 mt-0">
                                    <div className="row mb-2">
                                        <div className="col">
                                            <fieldset>
                                                <legend
                                                    className="radio-legend">{messages["opp.selectCustomer.label"]}</legend>
                                            </fieldset>
                                        </div>
                                        <div className="col-5">
                                            <fieldset>
                                                <legend className="radio-legend">{messages["opp.customerWallet.label"]}</legend>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {elements}
                    </div>
                </div>
            </div>
        );
    }


    /**
     * Whenever the agent selects a user in the registered users
     * section, we fetch the associated user's wallet PMs
     *
     * @param selectedUser
     */
    handleSelection(selectedUser) {
        const {onChangeUser} = this.props;

        onChangeUser({
            user: selectedUser,
            wallet: selectedUser.wallet
        });
    }

    getDisplayUserName(user) {
        let displayName = user.email;
        if (user.profile) {
            displayName = `${displayName} - ${user.profile.firstName} ${user.profile.lastName}`;
        }
        return displayName;
    }

}


const CARD_TYPE_MAP = {
    "VISA_DEBIT": "methodVisaDebit",
    "MC_DEBIT": "methodMastercardDebit",
    "VISA": "methodVisa",
    "MC": "methodMastercard",
    "AMEX": "methodAmex",
    "DISC": "methodDiscover",
    "DISC_DEBIT": "methodDiscoverDebit",
    "CHQ": "methodCheck",
    "SAV": "methodCheck"
};

function getCardCssClass(type) {
    return CARD_TYPE_MAP[type] ? CARD_TYPE_MAP[type] : "";
}


export default RegisteredUsers;
